import { AttachmentSpec } from '../../../attachments/spec/attachment-spec'

export class ProductionListPropertyResolveSpec {
  constructor(
    public type: ProductionListPropertyResolveType,
    // Only applies if type is KNOWN_PROPERTY
    public knownProperty: KnownProductionListProperties,
    // The following fields only apply if type is RESOLVED_PROPERTY
    public propertyId: string,
    public action: string,
    // Only applies if type is ATTACHMENT
    public attachment: AttachmentSpec
  ) {}
}

export enum ProductionListPropertyResolveType {
  KNOWN_PROPERTY = 'KNOWN_PROPERTY',

  RESOLVED_PROPERTY = 'RESOLVED_PROPERTY',

  ATTACHMENT = 'ATTACHMENT',
}

export enum KnownProductionListProperties {
  PROD_ORDER_ID = 'PROD_ORDER_ID',

  PROCESS_PLAN_NAME = 'PROCESS_PLAN_NAME',

  TOTAL_WEIGHT = 'TOTAL_WEIGHT',

  ITEM_DESCRIPTION = 'ITEM_DESCRIPTION',

  ITEM_SUMMARY = 'ITEM_SUMMARY',

  ROOT_MATERIAL = 'ROOT_MATERIAL',
}
